export default __webpack_public_path__ + "static/media/sm2.280b0ebb.png";